// src/components/Logo.js
// Oyuntu logosu: kart işareti + Baloo 2 yazı (Oyun Treni ile aynı aile).
import React from 'react';

export function LogoMark({ size = 38 }) {
  return (
    <svg className="logo-mark" width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="oy-lg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffb02e" />
          <stop offset="1" stopColor="#ff5a1f" />
        </linearGradient>
      </defs>
      <rect width="48" height="48" rx="14" fill="url(#oy-lg)" />
      <rect x="9" y="12" width="20" height="27" rx="4" fill="#1d1f24" opacity=".18" transform="rotate(-12 19 25)" />
      <rect x="17" y="8" width="21" height="29" rx="4.5" fill="#fff" transform="rotate(8 27 22)" />
      <path d="M27.6 30.2c-.2 0-.4-.1-.5-.2-3.6-3.1-5.6-4.9-5.6-7.2 0-1.7 1.3-3 2.9-3 1 0 1.9.5 2.5 1.3.6-.8 1.5-1.3 2.5-1.3 1.6 0 2.9 1.3 2.9 3 0 2.3-2 4.1-5.6 7.2-.3.1-.5.2-.6.2Z" fill="#e63946" transform="rotate(8 27 22)" />
    </svg>
  );
}

export default function Logo({ size = 38, sub }) {
  return (
    <span className="logo">
      <LogoMark size={size} />
      <span className="logo-text">
        <span className="logo-word">
          <span className="o">O</span>yuntu
        </span>
        {sub && <span className="logo-sub">{sub}</span>}
      </span>
    </span>
  );
}
